import React, { Component } from 'react';
import { TextField, FormControl, Button } from '@material-ui/core';
import styled from 'styled-components';
import { inject } from 'mobx-react';
import ErrorMessage from '../../components/ErrorMessage';
import { withPaymentCheck } from '../../hoc/withPaymentCheck';

const FormWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FormContainer = styled.div`
  max-width: 480px;
  width: 100%;
  background-color: #edf4ff;
  padding: 30px;
  border-radius: 5px;
`;

@inject('notesStore', 'routerStore')
class CreateNotePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toEmail: '',
      toName: '',
      body: '',
      errorMessage: null,
    };
  }

  handleSubmitNote = async () => {
    const { notesStore } = this.props;
    const { toEmail, toName, body } = this.state;

    try {
      await notesStore.createNote(toEmail, toName, body);
      window.location.hash = '/notes';
    } catch (error) {
      const errorMessage = error.response.data.message;
      this.setState({ errorMessage });
    }
  };

  render() {
    return (
      <FormWrapper>
        <FormContainer>
          <h1>Create a new note</h1>
          <p>Provide the message you would like sent to your loved one.</p>

          { this.state.errorMessage && <ErrorMessage message={this.state.errorMessage} />}

          <FormControl fullWidth>
            <TextField
              label="To Email"
              placeholder="To Email"
              margin="normal"
              variant="outlined"
              onChange={e => this.setState({ toEmail: e.target.value })}
            />
          </FormControl>
          <FormControl fullWidth>
            <TextField
              label="To Name"
              placeholder="To Name"
              margin="normal"
              variant="outlined"
              onChange={e => this.setState({ toName: e.target.value })}
            />
          </FormControl>
          <FormControl fullWidth>
            <TextField
              label="Note"
              placeholder="Note"
              multiline
              rows="8"
              margin="normal"
              variant="outlined"
              onChange={e => this.setState({ body: e.target.value })}
            />
          </FormControl>

          <Button
            style={{ marginTop: '10px' }}
            fullWidth
            variant="contained"
            color="primary"
            onClick={this.handleSubmitNote}
          >
            CREATE NOTE
          </Button>
        </FormContainer>
      </FormWrapper>
    );
  }
}

export default withPaymentCheck(CreateNotePage); // Wrap with HOC
